import { useForm } from '@mantine/form'
import { useRouter } from '@v2/commons/utils/navigation'
import { DEFAULT_ROUTES } from '@v2/domains/routing/types/routing.types'
import { getRoutePath } from '@v2/domains/routing/utils/route.utils'

import { useAppSelector } from 'src/v2/store/hooks'

import { selectCurrentOrganization } from '../selectors/user.selectors'
import { ICreateUserRequest, UserType } from '../user.types'
import { getUserFormValidation } from '../utils/user.validations'
import { useUserMutations } from './useUserMutations.hook'

export const useCreateUser = () => {
  const router = useRouter()

  const { createUser, isCreating } = useUserMutations()

  const { id: organizationId } = useAppSelector(selectCurrentOrganization)

  const userCreateForm = useForm<ICreateUserRequest>({
    mode: 'uncontrolled',
    initialValues: {
      id: '',
      username: '',
      firstName: '',
      lastName: '',
      phone: '',
      aircallUserId: '',
      password: '',
      organizationId: organizationId ?? '',
      type: UserType.REGULAR,
    },
    validateInputOnBlur: true,
    validate: getUserFormValidation(),
    transformValues: (values) => {
      const { phone, ...transformed } = values
      return {
        ...transformed,
        ...(!!phone ? { phone } : {}),
      }
    },
  })

  const onSubmit = () => {
    userCreateForm.onSubmit(async (values) => {
      const newUserId = await createUser({
        firstName: values.firstName,
        lastName: values.lastName,
        username: values.username,
        phone: values.phone,
        aircallUserId: values.aircallUserId || undefined,
        password: values.password,
        hipaaCertified: values.hipaaCertified,
        type: values.type,
      })

      if (newUserId) {
        router.push(
          `${getRoutePath(DEFAULT_ROUTES.ADMINISTRATION_USERS)}/${newUserId}`,
        )
      }
    })()
  }

  const handleCancelForm = () => {
    router.push(getRoutePath(DEFAULT_ROUTES.ADMINISTRATION_USERS))
  }

  return {
    userCreateForm,
    onSubmit,
    handleCancelForm,
    loading: isCreating,
  }
}
